<template>
  <div id="corporation" class="aboutus_wrapper">
    <v-header :status="true" />
    <!-- <v-header /> -->
    <div class="instruction">
      <img style="width:100%" src="../assets/img2/about_banner.png" />
      <img
        style="width:calc(100% - 70px);position: absolute;bottom:36px;left: 0px;margin: 0px 35px;"
        src="../assets/img2/about_report.png"
      />
    </div>
     <div style="margin-top:130px;" id="parter"><img class="agent-people-title" style="margin:0 auto; display: block;" src="../assets/img2/agent_people_title.png"/></div>
     <div  class="margin-top80"><img class="agent-people" style="margin:0 auto; display: block;" src="../assets/img2/agent_people.png"/></div>
    <div class="blue-box">
      <img style="width:100%;" src="../assets/img2/about_blue.png" />
    </div>
    <img
      id="vehicles"
      style="width:100%;display: block;"
      src="../assets/img2/about_banner_2.png"
    />
    <div class="advantage-box">
      <img src="../assets/img2/advantage_txt.png" />
      <div>
        <div>
          <div>品牌</div>
          <div>超强数据覆盖力</div>
        </div>

        <div>
          <div>专业</div>
          <div>
            汽车数据服务团队<br />
            最专业最高效的服务
          </div>
        </div>

        <div>
          <div>客户</div>
          <div>客户人群精准</div>
        </div>

        <div>
          <div>全面</div>
          <div>
            一站式服务<br />
            全方位解决问题
          </div>
        </div>
      </div>
      <img src="../assets/img2/wecom_qr.png" />
      <div>
        <div></div>
        <div>扫码了解详情</div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
import VHeader from "../components/Header.vue";
export default {
  name: "AGENT",
  components: { VHeader },
  mounted() {
    const that = this;
    if (document.getElementById(that.$route.query.hashId)) {
      document.getElementById(that.$route.query.hashId).scrollIntoView({block:'center'});
      that.$forceUpdate();
    }
    setTimeout(() => {
      if (document.getElementById(that.$route.query.hashId)) {
        document.getElementById(that.$route.query.hashId).scrollIntoView({block:'center'});
        that.$forceUpdate();
      }
    }, 200);
  },
};
</script>
<style lang="less" scoped>
.instruction {
  position: relative;
}
.margin-top40 {
  margin-top: 40px;
}
.margin-top80 {
  margin-top: 80px;
}

.advantage-box {
  background-image: url("../assets/img2/about_bottom_bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 140px 0px 100px 0px;
  > img:first-child {
    width: 416px;
    height: 132px;
    margin: 0 auto;
    display: block;
  }
  > div:nth-child(2) {
    display: flex;
    justify-content: center;
    margin: 132px 360px 120px 360px;
    div {
      cursor: pointer;
      flex: 1;
      text-align: center;
      &:hover {
        color: #0c3eb9 !important;
        div {
          color: #0c3eb9 !important;
        }
      }
      > div:first-child {
        font-size: 40px;
        font-weight: bold;
        color: #333333;
      }
      > div:last-child {
        font-size: 22px;
        color: #666666;
        margin-top: 110px;
        line-height: 40px;
      }
    }
  }
  > img:nth-child(3) {
    width: 378px;
    height: 378px;
    margin: 0 auto;
    display: block;
  }
  > div:last-child {
    font-size: 25px;
    font-weight: 400;
    color: #323232;
    font-weight: bold;
    margin: 76px 0px 0px 0px;
    display: flex;
    align-items: center;
    > div:first-child {
      flex: 1;
      border-top: 1px dashed #666666;
    }
    > div:nth-child(2) {
      margin: 0px 20px;
    }
    > div:last-child {
      flex: 1;
      border-top: 1px dashed #666666;
    }
  }
}
.blue-box {
  // background: #dcf8ff;
  width: 1477px;
  margin: 0 auto;
  margin-top: 80px;
  margin-bottom: 150px;
  // padding: 100px 0px 40px 160px;
}
.agent-people{
  width:1157px;
}
.agent-people-title{
  width:413px;
}
</style>
